// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableWrapper":"rq3YHT","pensionTable":"Cjtyis","rowHeader":"_1wra62","infoBtnWrapper":"_2d0mM6","infoBtn":"RbStiT"};